module.exports = __webpack_public_path__ + "static/media/back15.e6c6eaf0.jpg";